import React, { Component } from 'react'
import { observer } from 'mobx-react';
import { message, Icon, Popconfirm, Card, List, Tooltip, Button, Table } from 'utils/ui';
import { FaTicketAlt, FaStar, FaUtensils, FaDAndD, FaCampground, FaRegGem, FaGamepad, FaChess, FaTv, FaBlender, FaBath, FaHome, FaTableTennis, FaTimes, FaThLarge, FaListUl } from 'react-icons/fa'
import { findName, findImageLink, findNotes, findPrivateNotes } from '../api_calls/user';
import { FaReceipt, FaEyeSlash, FaBirthdayCake } from 'react-icons/fa'
import { buyGift, returnGift } from '../api_calls/gift';
import { colourMap, toSafeExternalUrl } from "../utils/gifts/helpers.js";
import ViewNotes from './ViewNotes';
import ViewPrivateNotes from './ViewPrivateNotes';
import _ from "underscore";
import FamilyStore from '../stores/FamilyStore';
import ModalShell from '../common/ModalShell';
import ModalBody from '../common/ModalBody';

const { Meta } = Card;
const defaultUserImage = require("../assets/unknown_user.png");

@observer(['CustomRouter', 'MyListStore', 'AuthStore', 'UserStore', 'FamilyStore'])
class SingleList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            thisUser: "User",
            thisUserImage: defaultUserImage,
            thisUserNotes: [],
            myNotesForThisUser: [],
            giftDescriptionModalOpen: false,
            displayMode: this.readDisplayMode(),
            isMobileView: this.readIsMobileView(),
            imageLoadFailed: false
        };
        this.padded = this.padded.bind(this);
        this.titlePadded = this.titlePadded.bind(this);
        this.handleViewportChange = this.handleViewportChange.bind(this);
        this.onUserImageError = this.onUserImageError.bind(this);
    }

    componentDidMount() {
        let self = this;
        const { UserStore, MyListStore, FamilyStore, CustomRouter } = this.props;
        let thisUserId = CustomRouter.router.params.userId;
        const auth = this.props.AuthStore.userAuth.auth.accessToken;
        MyListStore.loadGiftsForUser(thisUserId, UserStore.user._id, FamilyStore.activeGroupId);

        findName(thisUserId, auth).then((name) => {
            self.setState({ thisUserName: name, thisUserId });
        });

        findImageLink(thisUserId, auth).then((link) => {
            self.setState({ thisUserImage: link, imageLoadFailed: false });
        });

        findNotes(thisUserId, auth).then((notes) => {
            self.setState({ thisUserNotes: notes });
        });
        findPrivateNotes(UserStore.user._id, auth).then((notes) => {
            console.log(notes);

            let notesToUse = notes.filter(note => note.aboutPerson === thisUserId) || [];
            console.log(notesToUse);
            self.setState({ myNotesForThisUser: notesToUse });
        });

        if (typeof window !== "undefined") {
            window.addEventListener("resize", this.handleViewportChange);
        }
        this.handleViewportChange();
    }

    componentWillUnmount() {
        if (typeof window !== "undefined") {
            window.removeEventListener("resize", this.handleViewportChange);
        }
    }

    readIsMobileView() {
        if (typeof window === "undefined") {
            return false;
        }
        return window.matchMedia("(max-width: 900px)").matches;
    }

    handleViewportChange() {
        const isMobileView = this.readIsMobileView();
        if (isMobileView !== this.state.isMobileView) {
            this.setState({ isMobileView });
        }
        if (isMobileView && this.state.displayMode !== "cards") {
            this.setState({ displayMode: "cards" });
            try {
                window.localStorage.setItem("singleListGiftDisplayMode", "cards");
            } catch (error) {
                // Ignore persistence errors and keep runtime state.
            }
        }
    }

    readDisplayMode() {
        try {
            const mode = window.localStorage.getItem("singleListGiftDisplayMode");
            return mode === "table" ? "table" : "cards";
        } catch (error) {
            return "cards";
        }
    }

    getViewedUserRecord() {
        const { CustomRouter, FamilyStore, UserStore } = this.props;
        const thisUserId = CustomRouter.router.params.userId;
        return _.findWhere(FamilyStore.family.concat([UserStore.user]), { _id: thisUserId });
    }

    getDisplayedUserImage() {
        const fallbackImage = defaultUserImage;
        const viewedUser = this.getViewedUserRecord();
        const familyImage = viewedUser && viewedUser.profileImage;

        if (this.state.imageLoadFailed) {
            return fallbackImage;
        }

        if (familyImage === "" || !familyImage) {
            return fallbackImage;
        }

        return familyImage;
    }

    onUserImageError() {
        if (!this.state.imageLoadFailed) {
            this.setState({ imageLoadFailed: true });
        }
    }

    setDisplayMode(mode) {
        if (this.state.isMobileView) {
            return;
        }
        const normalized = mode === "table" ? "table" : "cards";
        this.setState({ displayMode: normalized });
        try {
            window.localStorage.setItem("singleListGiftDisplayMode", normalized);
        } catch (error) {
            // Ignore persistence errors and keep runtime state.
        }
    }

    determineCategoryIcon(category, chosenFontSize = 70) {
        let icon;
        let iconFontSize = String(chosenFontSize).concat("pt");
        switch (category) {
            case ("books"):
                icon = <Icon type="book" style={{ fontSize: iconFontSize }} />;
                break;
            case ("camping"):
                icon = <FaCampground style={{ fontSize: iconFontSize }} />;
                break;
            case ("clothing"):
                icon = <Icon type="skin" style={{ fontSize: iconFontSize }} />;
                break;
            case ("tools"):
                icon = <Icon type="tool" style={{ fontSize: iconFontSize }} />;
                break;
            case ("art"):
                icon = <Icon type="picture" style={{ fontSize: iconFontSize }} />;
                break;
            case ("food"):
                icon = <FaUtensils style={{ fontSize: iconFontSize }} />;
                break;
            case ("appliances"):
                icon = <FaBlender style={{ fontSize: iconFontSize }} />;
                break;
            case ("cosmetics"):
                icon = <FaBath style={{ fontSize: iconFontSize }} />;
                break;
            case ("technology"):
                icon = <FaTv style={{ fontSize: iconFontSize }} />;
                break;
            case ("household"):
                icon = <FaHome style={{ fontSize: iconFontSize }} />;
                break;
            case ("board games"):
                icon = <FaChess style={{ fontSize: iconFontSize }} />;
                break;
            case ("video games"):
                icon = <FaGamepad style={{ fontSize: iconFontSize }} />;
                break;
            case ("jewelry"):
                icon = <FaRegGem style={{ fontSize: iconFontSize }} />;
                break;
            case ("gift cards"):
                icon = <Icon type="credit-card" style={{ fontSize: iconFontSize }} />;
                break;
            case ("tickets"):
                icon = <FaTicketAlt style={{ fontSize: iconFontSize }} />;
                break;
            case ("d&d"):
                icon = <FaDAndD style={{ fontSize: iconFontSize }} />;
                break;
            case ("toys"):
                icon = <FaTableTennis style={{ fontSize: iconFontSize }} />;
                break;
            default: icon = <Icon type="gift" style={{ fontSize: iconFontSize }} />;
        }
        return icon;
    }

    confirmBought(gift) {
        console.log("buying gift " + gift);
        const { MyListStore, UserStore, FamilyStore } = this.props;
        let thisUser = this.props.CustomRouter.router.params.userId;
        if (UserStore.childViewActive && this.state.thisUserId === UserStore.activeChild.id) {
            message.warn("You cannot buy your own gift")
        } else {
            let purchaser = UserStore.childViewActive ? UserStore.activeChild.id : UserStore.user._id;
            buyGift(gift, purchaser, this.props.AuthStore.userAuth.auth.accessToken).then(() => {
                MyListStore.loadGiftsForUser(thisUser, UserStore.user._id, FamilyStore.activeGroupId);
            });
        }
    }

    confirmUnBought(gift) {
        console.log("un-buying gift " + gift);
        const { MyListStore, UserStore, FamilyStore } = this.props;
        let thisUser = this.props.CustomRouter.router.params.userId;

        returnGift(gift, this.props.AuthStore.userAuth.auth.accessToken).then(() => {
            MyListStore.loadGiftsForUser(thisUser, UserStore.user._id, FamilyStore.activeGroupId);
        });

    }

    padded(stringToPad, gift) {
        let teaserStringLength = 30;
        let teaserString;
        if (stringToPad.length === 0) {
            return <span><br /><br /></span>;
        }
        else if (stringToPad.length <= teaserStringLength) {
            return <span style={{ height: "32px", display: "block" }}>{stringToPad}</span>;
        } else {
            teaserString = stringToPad.slice(0, teaserStringLength) + "...";
            return <Button onClick={() => {
                this.setState({
                    descriptionTitle: gift.title,
                    descriptionText: stringToPad,
                    descPrice: gift.price,
                    giftDescriptionModalOpen: true
                })
            }}>{teaserString}</Button>;
        }
    }

    titlePadded(stringToPad) {
        let teaserStringLength = 22;
        let teaserString;
        if (stringToPad.length === 0) {
            return <span><br /><br /></span>;
        }
        else if (stringToPad.length <= teaserStringLength) {
            return stringToPad;
        } else {
            teaserString = stringToPad.slice(0, teaserStringLength) + " ...";
            return <span>
                <Tooltip title={stringToPad}>
                    {teaserString}
                </Tooltip>
            </span>
        }
    }

    isGiftPurchaser(purchaser) {
        const { UserStore, FamilyStore } = this.props;
        const isId = _.findWhere(FamilyStore.family.concat([UserStore.user]), { _id: purchaser });
        if (isId) {
            return purchaser === (UserStore.childViewActive ? UserStore.activeChild.id : UserStore.user._id);
        }
        return purchaser === (UserStore.childViewActive ? UserStore.activeChild.name : UserStore.user.name);
    }

    formatBirthday(month, day) {
        if (!month || !day) {
            return "Not set";
        }
        const date = new Date(2000, month - 1, day);
        return date.toLocaleDateString(undefined, { month: "long", day: "numeric" });
    }

    render() {
        const { MyListStore, UserStore, FamilyStore } = this.props;
        const theme = UserStore.theme();
        const toggleActiveStyle = {
            backgroundColor: theme.icons || "#1890ff",
            borderColor: theme.icons || "#1890ff",
            color: theme.font2 || "#fff",
            boxShadow: "0 6px 14px rgba(0,0,0,0.12)"
        };
        const toggleInactiveStyle = {
            backgroundColor: "rgba(255,255,255,0.82)",
            borderColor: theme.darkBackground || "#d9d9d9",
            color: theme.darkBackground || "#222"
        };
        let newArray = [];
        let thisUser = this.props.CustomRouter.router.params.userId;
        let ranks = _.findWhere(FamilyStore.family, { _id: thisUser }) ? _.findWhere(FamilyStore.family, { _id: thisUser }).listRank.get(FamilyStore.activeGroupId) : [];

        MyListStore.gifts.forEach(gift => {
            if (gift.wisher === thisUser) {
                newArray.push(gift);
            }
        });
        if (FamilyStore.activeGroup && FamilyStore.activeGroup.settings.allowRankings && ranks && ranks.length) {
            newArray.forEach((gift) => {
                delete gift.rank;
                ranks.forEach((rank, index) => {
                    if (rank === gift._id) {
                        gift.rank = index + 1;
                    }
                });
            });
            newArray = _.sortBy(newArray, thisGift => thisGift.rank || Infinity);
        }
        else {
            newArray.forEach((gift) => {
                delete gift.rank;
            });
        }
        const re = /^(?:https?:\/\/)?(?:www\.)?(?:[^\/]+\.)?([A-Za-z0-9-]+)\.[A-Za-z]{2,}(?:[\/:]|$)/i;
        const member = _.findWhere(FamilyStore.family, { _id: thisUser });
        const userBirthMonth = member && member.birthMonth ? member.birthMonth : 0;
        const userBirthDay = member && member.birthDay ? member.birthDay : 0;
        const birthdayText = this.formatBirthday(userBirthMonth, userBirthDay);
        const hasAnyNotes = this.state.thisUserNotes.length > 0 || this.state.myNotesForThisUser.length > 0;
        const tableDataSource = newArray.map((gift) => {
            const safeGiftLink = toSafeExternalUrl(gift.link);
            const domain = safeGiftLink && safeGiftLink.match(re) ? safeGiftLink.match(re)[1] : safeGiftLink;
            const canBuy = gift.purchaser === "" || gift.isInfinite || (gift.quantityWanted > 1 && gift.quantityPurchased < gift.quantityWanted);
            const canReturn = this.isGiftPurchaser(gift.purchaser);
            return {
                key: gift._id.toString(),
                title: gift.title,
                price: `$${Number(gift.price || 0).toFixed(2)}`,
                category: <span style={{ textTransform: "capitalize" }}>{gift.category || "uncategorized"}</span>,
                status: gift.purchaser && !gift.isInfinite && !(gift.quantityWanted - (gift.quantityPurchased || 0)) ? "Purchased" : (gift.isInfinite ? "Always Wanted" : `Wants ${Math.max(1, gift.quantityWanted - (gift.quantityPurchased || 0))}`),
                description: gift.description ? this.padded(gift.description, gift) : <span style={{ color: "#bfbfbf" }}>No description provided.</span>,
                link: safeGiftLink ? <a href={safeGiftLink} target="_blank" rel="noopener noreferrer">{domain}</a> : <span style={{ color: "#bfbfbf" }}>none</span>,
                actions: <div style={{ display: "flex", gap: 8, minWidth: 190 }}>
                    {canBuy ? (
                        <Popconfirm
                            title={`Are you sure you bought ${gift.title} for ${this.state.thisUserName}?`}
                            onConfirm={this.confirmBought.bind(this, gift._id)}
                            okText="Yes" cancelText="No"
                        >
                            <Button style={{ backgroundColor: "#1890ff", borderColor: "#1890ff", color: "#fff", fontWeight: 600 }}>
                                BUY
                            </Button>
                        </Popconfirm>
                    ) : null}
                    {canReturn ? (
                        <Popconfirm
                            title={`Are you sure you returned ${gift.title} for ${this.state.thisUserName}?`}
                            onConfirm={this.confirmUnBought.bind(this, gift._id)}
                            okText="Yes" cancelText="No"
                        >
                            <Button style={{ borderColor: "#d9d9d9", color: "#222", background: "#fff" }}>
                                RETURN
                            </Button>
                        </Popconfirm>
                    ) : null}
                </div>
            };
        });
        const formatGiftPrice = (price) => {
            if (price === undefined || price === null || price === "") {
                return null;
            }

            const parsedPrice = Number(price);
            if (Number.isNaN(parsedPrice)) {
                return null;
            }

            return `$${parsedPrice.toFixed(2)}`;
        };
        const tableColumns = [
            { title: "Title", dataIndex: "title", key: "title" },
            { title: "Price", dataIndex: "price", key: "price" },
            { title: "Category", dataIndex: "category", key: "category" },
            { title: "Status", dataIndex: "status", key: "status" },
            { title: "Description", dataIndex: "description", key: "description" },
            { title: "Link", dataIndex: "link", key: "link" },
            { title: "Actions", dataIndex: "actions", key: "actions" }
        ];
        const showingTable = !this.state.isMobileView && this.state.displayMode === "table";
        const listItems = newArray.map((gift) => {
            const safeGiftLink = toSafeExternalUrl(gift.link);
            const shouldShowPurchasedBySingleGift = !!gift.purchaser && !gift.isInfinite && (!gift.quantityWanted || Number(gift.quantityWanted) === 1);
            const giftPrice = formatGiftPrice(gift.price);
            return <List.Item key={gift._id.toString()} style={{ padding: 12 }}>
                <Card
                    actions={_.compact([
                        gift.purchaser === "" || gift.isInfinite || (gift.quantityWanted > 1 && gift.quantityPurchased < gift.quantityWanted) ?
                            <Popconfirm
                                title={`Are you sure you bought ${gift.title} for ${this.state.thisUserName}?`}
                                onConfirm={this.confirmBought.bind(this, gift._id)}
                                okText="Yes" cancelText="No"
                            >
                                <Button style={{ backgroundColor: "#1890ff", borderColor: "#1890ff", color: "#fff", fontWeight: 600 }}>
                                    <FaReceipt style={{ marginRight: 8 }} />BUY
                                </Button>
                            </Popconfirm>
                            : null,
                            this.isGiftPurchaser(gift.purchaser) ?
                                <Popconfirm
                                    title={`Are you sure you returned ${gift.title} for ${this.state.thisUserName}?`}
                                    onConfirm={this.confirmUnBought.bind(this, gift._id)}
                                    okText="Yes" cancelText="No"
                                >
                                    <Button style={{ borderColor: "#d9d9d9", color: "#222", background: "#fff" }}>
                                        <FaReceipt style={{ marginRight: 8 }} />RETURN
                                    </Button>
                                </Popconfirm>
                                : null
                    ])}
                    cover={
                        <div style={{ height: 168, display: "flex", alignItems: "center", justifyContent: "center", background: "#fafafa", borderBottom: "1px solid #eee", overflow: "hidden" }}>
                            {safeGiftLink ? <a href={safeGiftLink} target="_blank" rel="noopener noreferrer" style={{ display: "block", width: "100%", textAlign: "center", padding: 12 }}>
                                {gift.imageLink === "" ?
                                    <div style={{ display: "flex", width: "100%", height: "100%", alignItems: "center", justifyContent: "center", padding: 8, borderRadius: 8, background: "#fff" }}>
                                        <div>
                                        {this.determineCategoryIcon(gift.category, 60)}
                                        <div style={{ color: "#999", fontSize: 12 }}>
                                            {safeGiftLink.match(re) && safeGiftLink.match(re)[1]}
                                        </div>
                                        </div>
                                    </div>
                                    :
                                    <img
                                        alt={gift.title}
                                        src={gift.imageLink}
                                        style={{ width: "100%", height: 168, objectFit: "cover", borderRadius: 0, boxShadow: "none" }}
                                    />
                                }
                            </a> : <div style={{ display: "block", width: "100%", textAlign: "center", padding: 12 }}>
                                {gift.imageLink === "" ?
                                    <div style={{ display: "flex", width: "100%", height: "100%", alignItems: "center", justifyContent: "center", padding: 8, borderRadius: 8, background: "#fff" }}>
                                        {this.determineCategoryIcon(gift.category, 60)}
                                    </div>
                                    :
                                    <img
                                        alt={gift.title}
                                        src={gift.imageLink}
                                        style={{ width: "100%", height: 168, objectFit: "cover", borderRadius: 0, boxShadow: "none" }}
                                    />
                                }
                            </div>}
                        </div>
                    }
                    bordered={false}
                    style={{ borderRadius: 8, overflow: "visible", boxShadow: "0 6px 18px rgba(0,0,0,0.08)", backgroundColor: "#fff", minHeight: "24rem", position: "relative", display: "flex", flexDirection: "column", justifyContent: "space-between" }}
                >
                    {/* Price / purchased badge */}
                    <div style={{ position: "absolute", top: 12, right: 12, minHeight: 32, display: "flex", alignItems: "center" }}>
                    {giftPrice ? (<div style={{
                        background: "#fff",
                        color: "#1890ff",
                        padding: "6px 10px",
                        borderRadius: 6,
                        fontWeight: 700,
                        fontSize: "13px",
                        border: "1px solid #d9e9ff",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        marginRight: 8
                    }}>{giftPrice}</div>) : null}
                        {gift.purchaser && !gift.isInfinite && !(gift.quantityWanted - gift.quantityPurchased) ? ( <div style={{
                        background: "#fff1f0",
                        color: "#cf1322",
                        padding: "6px 10px",
                        borderRadius: 20,
                        fontWeight: 700,
                        fontSize: "13px",
                        border: "1px solid #ffd8d8"
                    }}>Purchased</div>) : ""}
                    {gift.purchaser && (gift.isInfinite || gift.quantityWanted > 1) && (!!(gift.quantityWanted - gift.quantityPurchased) || gift.isInfinite) ? (<div style={{
                        background: "#fff1f0",
                        color: "#13a3cf",
                        padding: "6px 10px",
                        borderRadius: 20,
                        fontWeight: 700,
                        fontSize: "13px",
                        border: "1px solid #ffd8d8"
                    }}>Last Purchase: {new Date(gift.timePurchased).toLocaleDateString()}</div>) : ""}
                    {gift.isInfinite ? (<div style={{
                        background: "#fff1f0",
                        color: "#e272c6",
                        padding: "6px 10px",
                        borderRadius: 20,
                        fontWeight: 700,
                        fontSize: "13px",
                        border: "1px solid #ffd8d8"
                    }}>Always Wanted</div>) : ""}
                    {gift.quantityWanted > 1 && gift.quantityWanted - gift.quantityPurchased > 0 && !gift.isInfinite ? (<div style={{
                        background: "#fff1f0",
                        color: "#e272c6",
                        padding: "6px 10px",
                        borderRadius: 20,
                        fontWeight: 700,
                        fontSize: "13px",
                        border: "1px solid #ffd8d8",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8
                    }}>
                        Wants {gift.quantityWanted - (gift.quantityPurchased || 0)} {gift.quantityPurchased ? 'more' : ''}
                        <div
                            style={{
                                width: 16,
                                height: 16,
                                borderRadius: "50%",
                                background: `conic-gradient(#e272c6 ${Math.max(0, Math.min(100, Math.round((((gift.quantityPurchased || 0) / (gift.quantityWanted || 1)) * 100))))}%, #f3d9ec 0)`,
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            title={`${Math.max(0, Math.min(100, Math.round((((gift.quantityPurchased || 0) / (gift.quantityWanted || 1)) * 100))))}% purchased`}
                        >
                            <div style={{ width: 9, height: 9, borderRadius: "50%", background: "#fff1f0" }}></div>
                        </div>
                    </div>) : ""}
                    </div>

                    

                    {/* Rank badge */}
                    {gift.rank ? (
                        <div style={{ position: "absolute", top: 12, left: 12, display: "flex", alignItems: "center", padding: "4px 8px", borderRadius: 6, backgroundColor: colourMap[gift.rank], color: "#fff", fontWeight: 700 }}>
                            <span style={{ marginRight: 6 }}>{gift.rank}</span>
                            {gift.rank === 1 ? <FaStar /> : null}
                        </div>
                    ) : null}

                    {/* Content */}
                    <div style={{ padding: "18px 8px 12px 8px", flexGrow: 1, display: "flex", flexDirection: "column" }}>
                        {gift.purchaser === "" || gift.isInfinite || (gift.quantityWanted - (gift.quantityPurchased || 0) > 0) ? (
                            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                <div style={{ fontSize: 16, fontWeight: 700, color: "#111", lineHeight: 1.2, minHeight: "2.4em", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>{this.titlePadded(gift.title)}</div>
                                <div style={{ color: "#555", fontSize: 13, lineHeight: 1.4, minHeight: "3.6em", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical" }}>{this.padded(gift.description, gift)}</div>
                                {shouldShowPurchasedBySingleGift ? (
                                    <div style={{ color: "#888", fontSize: 13 }}>
                                        <span style={{ color: "#555", marginRight: 6 }}>bought by</span>
                                        <span style={{ color: "#cf1322", fontWeight: 700, fontSize: 15 }}>
                                            {gift.purchaserName || (_.findWhere(FamilyStore.family.concat([UserStore.user]), { _id: gift.purchaser }) ?
                                                _.findWhere(FamilyStore.family.concat([UserStore.user]), { _id: gift.purchaser }).name : gift.purchaser)}
                                        </span>
                                        <div style={{ marginTop: 6, color: "#999", fontSize: 12 }}>
                                            on {new Date(gift.timePurchased).toLocaleDateString()}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                <div style={{ fontSize: 15, fontWeight: 700, color: "#111", lineHeight: 1.2, minHeight: "2.4em", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>{this.titlePadded(gift.title)}</div>
                                <div style={{ color: "#888", fontSize: 13 }}>
                                    <span style={{ color: "#555", marginRight: 6 }}>bought by</span>
                                    <span style={{ color: "#cf1322", fontWeight: 700, fontSize: 15 }}>
                                        {gift.purchaserName || (_.findWhere(FamilyStore.family.concat([UserStore.user]), { _id: gift.purchaser }) ?
                                            _.findWhere(FamilyStore.family.concat([UserStore.user]), { _id: gift.purchaser }).name : gift.purchaser)}
                                    </span>
                                    <div style={{ marginTop: 6, color: "#999", fontSize: 12 }}>
                                        on {new Date(gift.timePurchased).toLocaleDateString()}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <Meta
                        avatar={null}
                        title={null}
                        description={null}
                    />
                </Card>
            </List.Item>
        }
        );
        return (
            <div className="single-list-container">
                <style>{`
                .single-list-container {
                padding: 28px 18px;
                box-sizing: border-box;
                min-height: 100vh;
                display: flex;
                flex-direction: column;
                align-items: center;
                }

                /* Modal */
                .gift-description-modal-overlay {
                background: rgba(0,0,0,0.6) !important;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 20px;
                z-index: 1000;
                }
                .gift-description-modal {
                background: #fff;
                border-radius: 12px;
                width: 100%;
                max-width: 760px;
                box-shadow: 0 20px 40px rgba(2,6,23,0.45);
                padding: 22px 24px;
                position: relative;
                outline: none;
                }
                .gift-modal-close {
                position: absolute;
                top: 12px;
                right: 12px;
                cursor: pointer;
                color: #666;
                font-size: 22px;
                }
                .gift-modal-body {
                text-align: center;
                padding: 8px 8px 4px;
                }
                .gift-modal-title {
                display: block;
                font-weight: 700;
                color: #0f1723;
                font-size: clamp(20px, 3.6vw, 30px);
                margin-bottom: 6px;
                }
                .gift-modal-price {
                color: #1677ff;
                font-weight: 800;
                font-size: clamp(18px, 6vw, 36px);
                display: block;
                margin-bottom: 12px;
                }
                .gift-modal-desc {
                color: #374151;
                font-size: clamp(14px, 2.4vw, 18px);
                line-height: 1.45;
                }

                /* Header */
                .single-list-header {
                width: 100%;
                max-width: 1100px;
                display: flex;
                align-items: center;
                gap: 20px;
                margin-bottom: 18px;
                }
                .avatar-wrap {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                min-width: 120px;
                }
                .avatar-img {
                width: 140px;
                height: 140px;
                border-radius: 50%;
                object-fit: cover;
                border: 4px solid rgba(255,255,255,0.08);
                box-shadow: 0 6px 18px rgba(2,6,23,0.5);
                background: #fff;
                }
                .user-title {
                color: #fff;
                font-weight: 700;
                font-size: clamp(18px, 3.6vw, 32px);
                margin-top: 12px;
                text-align: center;
                }

                /* Notes */
                .notes-container {
                width: 100%;
                max-width: 1100px;
                margin-top: 10px;
                margin-bottom: 10px;
                padding: 16px 18px;
                border-radius: 16px;
                background: rgba(255, 255, 255, 0.36);
                backdrop-filter: blur(4px);
                box-shadow: 0 8px 22px rgba(15, 23, 42, 0.12);
                }

                /* Gifts list area */
                .gifts-container {
                width: 100%;
                max-width: 1100px;
                margin-top: 18px;
                margin-bottom: 36px;
                display: block;
                }

                .no-peeking {
                width: 100%;
                text-align: center;
                color: #fff;
                margin-top: 8vh;
                }

                /* Responsive adjustments */
                @media (max-width: 720px) {
                .single-list-header {
                    flex-direction: column;
                    align-items: center;
                }
                .avatar-img {
                    width: 110px;
                    height: 110px;
                }
                .gifts-container {
                    padding: 0 6px;
                }
                }
            `}</style>

                <ModalShell
                    className="gift-description-modal"
                    overlayClassName="gift-description-modal-overlay"
                    isOpen={this.state.giftDescriptionModalOpen}
                    onRequestClose={() => { this.setState({ giftDescriptionModalOpen: false }) }}
                >
                    <ModalBody>
                        <div className="gift-modal-close" onClick={() => { this.setState({ giftDescriptionModalOpen: false }) }}>
                            <FaTimes />
                        </div>
                        <div className="gift-modal-body">
                            <span className="gift-modal-title AppFont">{this.state.descriptionTitle}</span>
                            <span className="gift-modal-price">${this.state.descPrice}</span>
                            <p className="gift-modal-desc">{this.state.descriptionText}</p>
                        </div>
                    </ModalBody>
                </ModalShell>

                <div className="single-list-header">
                    <div className="list-two-column-layout">
                        <aside className="list-profile-rail">
                            <div className="list-profile-card">
                                <img
                                    className="member-img avatar-img list-profile-avatar"
                                    alt={`${this.state.thisUserName || "User"} avatar`}
                                    src={this.getDisplayedUserImage()}
                                    onError={this.onUserImageError}
                                />
                                <div>
                                    <div className="list-profile-name AppFont">{(this.state.thisUserName || "User") + "'s List"}</div>
                                    <div className="list-profile-role"></div>
                                    <div className="list-profile-birthday">
                                        <div className="list-profile-birthday-label"><FaBirthdayCake style={{ marginRight: 6 }} /> Birthday</div>
                                        <div className="list-profile-birthday-value">{birthdayText}</div>
                                    </div>
                                </div>
                            </div>
                        </aside>

                        <section className="list-main-pane">
                            {hasAnyNotes ? (
                                <div className="notes-container">
                                    {this.state.thisUserNotes.length === 0 ? null : <ViewNotes notes={this.state.thisUserNotes} />}
                                    {this.state.myNotesForThisUser.length === 0 ? null : <ViewPrivateNotes user={this.state.thisUserName} notes={this.state.myNotesForThisUser} />}
                                </div>
                            ) : null}

                            <div className="gifts-container">
                                {!MyListStore.loaded ? (
                                    <div style={{ textAlign: "center", color: "#fff", paddingTop: 40 }}>
                                        <Icon type="loading" style={{ fontSize: 30, color: "#fff" }} />
                                    </div>
                                ) : (
                                    listItems.length > 0 ? (
                                        (UserStore.childViewActive ? (thisUser === UserStore.activeChild.id) : (thisUser === UserStore.user._id)) ? (
                                            <h1 className="AppFont no-peeking" style={{ fontSize: "34px" }}><FaEyeSlash /> No peeking!</h1>
                                        ) : (
                                            <div style={{ marginTop: 6 }}>
                                                {this.state.isMobileView ? null : (
                                                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 14 }}>
                                                        <Button
                                                            onClick={() => { this.setDisplayMode("cards") }}
                                                            style={showingTable ? toggleInactiveStyle : toggleActiveStyle}
                                                        >
                                                            <FaThLarge style={{ marginRight: 8 }} />Cards
                                                        </Button>
                                                        <Button
                                                            onClick={() => { this.setDisplayMode("table") }}
                                                            style={showingTable ? toggleActiveStyle : toggleInactiveStyle}
                                                        >
                                                            <FaListUl style={{ marginRight: 8 }} />Table
                                                        </Button>
                                                    </div>
                                                )}

                                                {showingTable ? (
                                                    <Table dataSource={tableDataSource} columns={tableColumns} />
                                                ) : (
                                                    <List
                                                        grid={{
                                                            gutter: 16, xs: 1, sm: 1, md: 2, lg: 3, xl: 3, xxl: 3,
                                                        }}
                                                    >
                                                        {listItems}
                                                    </List>
                                                )}
                                            </div>
                                        )
                                    ) : (
                                        <h1 className="AppFont no-peeking" style={{ fontSize: "28px" }}>No gifts found</h1>
                                    )
                                )}
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        )
    }
}
export default SingleList;